import { render, staticRenderFns } from "./photoswipe.vue?vue&type=template&id=26a7c8e3&"
import script from "./photoswipe.vue?vue&type=script&lang=js&"
export * from "./photoswipe.vue?vue&type=script&lang=js&"
import style0 from "./photoswipe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports